(function enableHanezzaGlobalDrawers(win) {
  'use strict';

  if (!win || !win.document) return;

  var doc = win.document;
  var TRANSITION_MS = 340;

  function setAccessibleLayerState(element, open, immediate) {
    if (!element) return;

    element.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      element.removeAttribute('inert');
      element.style.visibility = 'visible';
      element.style.pointerEvents = '';
      return;
    }

    element.setAttribute('inert', '');
    var hide = function () {
      element.style.visibility = 'hidden';
      element.style.pointerEvents = 'none';
    };

    if (immediate) hide();
    else win.setTimeout(hide, TRANSITION_MS);
  }

  function ensureImageDimensions(image, fallbackWidth, fallbackHeight) {
    if (!image) return;
    if (!image.getAttribute('width')) image.setAttribute('width', String(fallbackWidth));
    if (!image.getAttribute('height')) image.setAttribute('height', String(fallbackHeight));
  }

  function enhanceMarkup() {
    var navDrawer = doc.querySelector('.nav-drawer');
    var searchDrawer = doc.querySelector('.search-drawer');
    var navOverlay = doc.querySelector('.drawer-overlay');
    var searchOverlay = doc.querySelector('.search-drawer-overlay');

    var navClose = navDrawer && navDrawer.querySelector('button[onclick*="closeNavDrawer"]');
    var searchClose = searchDrawer && searchDrawer.querySelector('button[onclick*="closeSearchDrawer"]');
    if (navClose && !navClose.getAttribute('aria-label')) navClose.setAttribute('aria-label', 'Menüyü kapat');
    if (searchClose && !searchClose.getAttribute('aria-label')) searchClose.setAttribute('aria-label', 'Aramayı kapat');

    if (navDrawer) {
      var primaryLogo = navDrawer.querySelector('img.object-contain:not(.w-24)');
      var decorativeLogo = navDrawer.querySelector('img.w-24.h-24');
      ensureImageDimensions(primaryLogo, 200, 113);
      ensureImageDimensions(decorativeLogo, 96, 96);
    }

    setAccessibleLayerState(navDrawer, navDrawer ? navDrawer.classList.contains('open') : false, true);
    setAccessibleLayerState(searchDrawer, searchDrawer ? !searchDrawer.classList.contains('-translate-y-full') : false, true);
    setAccessibleLayerState(navOverlay, false, true);
    setAccessibleLayerState(searchOverlay, false, true);
  }

  function moveSearchDrawerOutsideMobileWrapper() {
    if (!doc.body) return;
    doc.querySelectorAll('.mobile-global-elements').forEach(function (wrapper) {
      var searchOverlay = wrapper.querySelector(':scope > .search-drawer-overlay');
      var searchDrawer = wrapper.querySelector(':scope > .search-drawer');

      [searchOverlay, searchDrawer].forEach(function (element) {
        if (!element || element.parentElement !== wrapper) return;
        element.setAttribute('data-hanezza-global-drawer', 'search');
        doc.body.appendChild(element);
      });

      wrapper.setAttribute('data-hanezza-mobile-elements', 'preserved');
    });
  }

  function wrapDrawerFunctions() {
    if (!win.__hanezzaDrawerFunctionsWrapped) {
      var originalOpenNav = win.openNavDrawer;
      var originalCloseNav = win.closeNavDrawer;
      var originalOpenSearch = win.openSearchDrawer;
      var originalCloseSearch = win.closeSearchDrawer;

      if (typeof originalOpenNav === 'function') {
        win.openNavDrawer = function () {
          var drawer = doc.querySelector('.nav-drawer');
          var overlay = doc.querySelector('.drawer-overlay');
          setAccessibleLayerState(drawer, true, true);
          setAccessibleLayerState(overlay, true, true);
          return originalOpenNav.apply(this, arguments);
        };
      }

      if (typeof originalCloseNav === 'function') {
        win.closeNavDrawer = function () {
          var result = originalCloseNav.apply(this, arguments);
          setAccessibleLayerState(doc.querySelector('.nav-drawer'), false, false);
          setAccessibleLayerState(doc.querySelector('.drawer-overlay'), false, false);
          return result;
        };
      }

      if (typeof originalOpenSearch === 'function') {
        win.openSearchDrawer = function () {
          var drawer = doc.querySelector('.search-drawer');
          var overlay = doc.querySelector('.search-drawer-overlay');
          setAccessibleLayerState(drawer, true, true);
          setAccessibleLayerState(overlay, true, true);
          return originalOpenSearch.apply(this, arguments);
        };
      }

      if (typeof originalCloseSearch === 'function') {
        win.closeSearchDrawer = function () {
          var result = originalCloseSearch.apply(this, arguments);
          setAccessibleLayerState(doc.querySelector('.search-drawer'), false, false);
          setAccessibleLayerState(doc.querySelector('.search-drawer-overlay'), false, false);
          return result;
        };
      }

      win.__hanezzaDrawerFunctionsWrapped = true;
    }
  }

  function apply() {
    moveSearchDrawerOutsideMobileWrapper();
    enhanceMarkup();
    wrapDrawerFunctions();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  if ('MutationObserver' in win) {
    var observer = new MutationObserver(function (mutations) {
      var shouldApply = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node && node.nodeType === 1 && (
            node.matches && node.matches('.mobile-global-elements, .search-drawer, .nav-drawer') ||
            node.querySelector && node.querySelector('.mobile-global-elements, .search-drawer, .nav-drawer')
          );
        });
      });
      if (shouldApply) apply();
    });
    observer.observe(doc.documentElement, { childList: true, subtree: true });
  }

  win.HanezzaGlobalDrawerFix = { apply: apply };
})(typeof window !== 'undefined' ? window : null);
